<div [formGroup]="packagesForm" class="mt-5 mx-5" #localFormRef="ngForm">
	<div class="row" formArrayName="packsArray">
		<table class="table">
			<thead>
				<tr>
					<th>N°</th>
					<th>Código</th>
					<th>Cantidad</th>
					<th>Marcas</th>
					<th>Id Container</th>
					<th>Sello</th>
					<th>Emisor Sello</th>
					<th></th>
				</tr>
			</thead>
			<tbody *ngFor="let package of packagesForm.get('packsArray')['controls']; let i = index">
				<tr [formGroupName]="i">
					<td>{{ i + 1 }}</td>
					<td WIDTH="20%">
						<ng-select [items]="codigoTipoBultoSource" [clearable]="false" [multiple]="false" formControlName="codigotipoBulto" bindLabel="descripcion" (blur)="submit()"></ng-select>
						<div *ngIf="(localFormRef.touched || localFormRef.dirty) && packagesForm.get('packsArray')['controls'][i].invalid" class="text-danger">
							<div *ngIf="packagesForm.get('packsArray')['controls'][i].get('codigotipoBulto').errors?.required">Campo Requerido</div>
						</div>
					</td>
					<td>
						<input type="number" class="form-control" formControlName="cantidadBulto" (blur)="submit()" />
						<div *ngIf="(localFormRef.touched || localFormRef.dirty) && packagesForm.get('packsArray')['controls'][i].invalid" class="text-danger">
							<div *ngIf="packagesForm.get('packsArray')['controls'][i].get('cantidadBulto').errors?.required">Campo Requerido</div>
						</div>
					</td>
					<td>
						<input type="text" class="form-control" formControlName="marcas" (blur)="submit()" />
						<!-- <div *ngIf="(localFormRef.touched || localFormRef.dirty) &&  packagesForm.get('packsArray')['controls'][i].invalid"
                            class="text-danger">
                            <div *ngIf="packagesForm.get('packsArray')['controls'][i].get('marcas').errors?.required">
                                Campo Requerido</div>
                        </div> -->
					</td>
					<td>
						<input type="text" class="form-control" formControlName="idContainer" (blur)="submit()" />
						<div *ngIf="(localFormRef.touched || localFormRef.dirty) && packagesForm.get('packsArray')['controls'][i].invalid" class="text-danger">
							<div *ngIf="packagesForm.get('packsArray')['controls'][i].get('idContainer').errors?.required">Campo Requerido</div>
						</div>
					</td>
					<td>
						<input type="text" class="form-control" formControlName="sello" (blur)="submit()" />
						<div *ngIf="(localFormRef.touched || localFormRef.dirty) && packagesForm.get('packsArray')['controls'][i].invalid" class="text-danger">
							<div *ngIf="packagesForm.get('packsArray')['controls'][i].get('sello').errors?.required">Campo Requerido</div>
						</div>
					</td>
					<td>
						<input type="text" class="form-control" formControlName="emisorSello" (blur)="submit()" />
						<div *ngIf="(localFormRef.touched || localFormRef.dirty) && packagesForm.get('packsArray')['controls'][i].invalid" class="text-danger">
							<div *ngIf="packagesForm.get('packsArray')['controls'][i].get('emisorSello').errors?.required">Campo Requerido</div>
						</div>
					</td>
					<td>
						<button class="btn btn-danger" (click)="removePackageForm(i)"><i class="flaticon-delete text-white"></i></button>
					</td>
				</tr>
			</tbody>
		</table>
		<!-- <div *ngFor="let package of packagesForm.get('packsArray')['controls'];let i= index" class="col-12">
            <div [formGroupName]="i" class="row">
                <div class="col-4 form-group mx-auto">
                    <div class="row">
                        <div class="col-4 label-control">
                            Tipo Bulto
                        </div>
                        <div class="col-8">
                            <ng-select [items]="codigoTipoBultoSource" [clearable]="false" [multiple]="false"
                                formControlName="codigotipoBulto"></ng-select>
                        </div>
                    </div>
                </div>
                <div class="col-4 form-group mx-auto">
                    <div class="row">
                        <div class="col-4 label-control">
                            Cantidad Bulto
                        </div>
                        <div class="col-8">
                            <input type="text" class="form-control" formControlName="cantidadBulto">
                        </div>
                    </div>
                </div>
                <div class="col-4 form-group mx-auto">
                    <div class="row">
                        <div class="col-4 label-control">
                            Marcas
                        </div>
                        <div class="col-8">
                            <input type="text" class="form-control" formControlName="marcas">
                        </div>
                    </div>
                </div>
                <div class="col-4 form-group mx-auto">
                    <div class="row">
                        <div class="col-4 label-control">
                            Id Container
                        </div>
                        <div class="col-8">
                            <input type="text" class="form-control" formControlName="idContainer">
                        </div>
                    </div>
                </div>
                <div class="col-4 form-group mx-auto">
                    <div class="row">
                        <div class="col-4 label-control">
                            Sello
                        </div>
                        <div class="col-8">
                            <input type="text" class="form-control" formControlName="sello">
                        </div>
                    </div>
                </div>
                <div class="col-4 form-group mx-auto">
                    <div class="row">
                        <div class="col-4 label-control">
                            Emisor Sello
                        </div>
                        <div class="col-8">
                            <input type="text" class="form-control" formControlName="emisorSello">
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
	</div>
	<div class="mb-5">
		<div class="d-flex justify-content-center">
			<button class="btn btn-success" (click)="addPackageForm()"><i class="flaticon-add-circular-button"></i>Agregar Paquete</button>
		</div>
	</div>
</div>
